import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-background text-white selection:bg-neon-cyan selection:text-black" data-id="element-223">
      <Navbar data-id="element-224" />
      <main data-id="element-225">
        <Hero data-id="element-226" />
        <ProblemSection data-id="element-227" />
        <SolutionSection data-id="element-228" />
        <FeaturesSection data-id="element-229" />
        <PricingSection data-id="element-230" />
      </main>
      <Footer data-id="element-231" />
    </div>;
}